import {useEffect, useState} from 'react';

import {AsyncThunkAction} from '@reduxjs/toolkit';
import {AppDispatch} from 'ui/store';
import {AsyncThunkConfig} from 'ui/store/survey/survey.types';
import queueRequests from 'ui/utils/queueRequests';

type Action = AsyncThunkAction<unknown, unknown, AsyncThunkConfig<void>>;
interface UsePrepareData {
    (actions: Action[], dispatch: AppDispatch): boolean;
}

const usePrepareData: UsePrepareData = (actions, dispatch) => {
    const [prepared, setComplete] = useState(false);

    useEffect(() => {
        const actionList: ReturnType<Action>[] = [];
        const requests = actions.map((action) => () => {
            const request = dispatch(action);
            actionList.push(request);
            return request.unwrap();
        });

        queueRequests(requests)
            .then(() => setComplete(true))
            .catch(() => {});

        return () => {
            for (const action of actionList) {
                if ('abort' in action) {
                    action.abort();
                }
            }
        };
    }, []);

    return prepared;
};

export default usePrepareData;
